import { render, staticRenderFns } from "./PipelineStageDeleteButton.vue?vue&type=template&id=6783fcc4&"
import script from "./PipelineStageDeleteButton.vue?vue&type=script&lang=js&"
export * from "./PipelineStageDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports